module.exports = __webpack_public_path__ + "media/images/icons/check-light-171cde5dd24cf9972b2aaa9660ff6133.svg";